import React, { createContext, useContext, useEffect } from 'react';
import nativeWebSocket from './websocket-native';
import { useUser } from './UserContext';

const WebSocketContext = createContext();

export const WebSocketProvider = ({ children }) => {
  const { user } = useUser();

  useEffect(() => {
    // Conectar WebSocket cuando el usuario esté autenticado
    if (user && user.id) {
      const currentState = nativeWebSocket.getConnectionState();
      if (currentState !== 'connected' && currentState !== 'connecting') {
        console.log('🔌 WebSocket conectando...');
        nativeWebSocket.connect();
      }
    } else {
      // Desconectar si no hay usuario
      nativeWebSocket.disconnect();
    }

    // Cleanup al desmontar o cuando cambie el usuario
    return () => {
      if (!user) {
        nativeWebSocket.disconnect();
      }
    };
  }, [user]);

  // Reconectar cuando se recupere la conexión a internet
  useEffect(() => {
    const handleOnline = () => {
      if (user && user.id) {
        const currentState = nativeWebSocket.getConnectionState();
        if (currentState !== 'connected' && currentState !== 'connecting') {
          console.log('🌐 Conexión a Internet restaurada, reconectando WebSocket...');
          setTimeout(() => {
            const state = nativeWebSocket.getConnectionState();
            if (state !== 'connected' && state !== 'connecting') {
              nativeWebSocket.connect();
            }
          }, 2000);
        }
      }
    };

    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('online', handleOnline);
    };
  }, [user]);

  return (
    <WebSocketContext.Provider value={{ websocket: nativeWebSocket }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error('useWebSocket debe ser usado dentro de WebSocketProvider');
  }
  return context;
};